import React from "react";
import { CheckCircle } from "lucide-react";
import Freelancercycle from "./Freelancercycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Skyrocket Your Freelancer and Consultant Sales Using WhatsApp",
  points: [
    "Automate FAQs to answer client questions swiftly and efficiently.",
    "Send secure, encrypted e-invoices directly for ongoing projects.",
    "Keep clients connected with personalized updates and notifications.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Schedule a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Freelancer/Freelancer_1.png",
};


const freelancerServices = [
  {
    id: 1,
    icon: <span className="text-2xl">💼</span>, // Briefcase icon
    title: "Win Clients with WhatsApp Proposals",
    description: "Send personalized project quotes, timelines, and portfolios via WhatsApp. It’s like shaking hands virtually—building trust and closing deals faster!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">📧</span>, // Email icon
    title: "Follow Up Efficiently on WhatsApp",
    description: "Keep leads warm with timely updates and check-ins through WhatsApp. It’s less intrusive than email and more personal—perfect for freelancers."
  },
  {
    id: 3,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Consultations via WhatsApp",
    description: "Schedule quick strategy sessions or Q&A calls using WhatsApp. Clients love the flexibility and direct access to your expertise."
  },
  {
    id: 4,
    icon: <span className="text-2xl">📈</span>, // Chart icon
    title: "Track Projects with WhatsApp Updates",
    description: "Share progress reports, milestones, and deadlines via WhatsApp. It keeps clients in the loop and shows you’re on top of everything."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💰</span>, // Money icon
    title: "Simplify Payments on WhatsApp",
    description: "Invoicing and payment links can be sent and tracked through WhatsApp. It’s secure, fast, and your clients will appreciate the ease."
  },
  {
    id: 6,
    icon: <span className="text-2xl">🤝</span>, // Handshake icon
    title: "Build Loyalty with WhatsApp Tips",
    description: "Share industry insights, free resources, or referral incentives via WhatsApp. It turns one-time clients into lifelong partners."
  }
];

const freelancerFAQs = [
  {
    question: "How can WhatsApp help me land more freelance clients?",
    answer: "WhatsApp can boost your client base by sending personalized proposals and follow-ups directly to prospects. It’s like having a virtual handshake that builds trust and closes deals faster than email ever could!"
  },
  {
    question: "Is WhatsApp secure for sharing freelance project details?",
    answer: "Yes, WhatsApp’s encryption keeps your proposals, timelines, and client data safe. It’s like locking your work in a vault, so you can focus on impressing clients without worry."
  },
  {
    question: "Can I schedule consultations on WhatsApp?",
    answer: "Absolutely! Clients can book strategy sessions or Q&A calls via WhatsApp with ease. It’s like having a flexible calendar that fits their schedule, making you their go-to expert."
  },
  {
    question: "How does WhatsApp help follow up with leads?",
    answer: "Send timely check-ins and project updates through WhatsApp to keep leads warm. It’s less intrusive than calls and more personal than emails, keeping you top of mind."
  },
  {
    question: "Can WhatsApp simplify invoicing for freelancers?",
    answer: "Yes! Share invoices, payment links, and reminders via WhatsApp. It’s like streamlining your cash flow into a single chat, saving time and impressing clients."
  },
  {
    question: "What kind of content should I share on WhatsApp as a freelancer?",
    answer: "Share portfolio samples, industry tips, and referral incentives via WhatsApp. It’s like building a brand that clients can’t resist, turning one-off gigs into long-term partnerships."
  },
  {
    question: "How do clients feel about using WhatsApp for freelance work?",
    answer: "They love it! Clients appreciate the speed, convenience, and personal touch of WhatsApp. It’s like having a direct line to your expertise, making collaboration a breeze."
  },
  {
    question: "Can WhatsApp reduce my marketing costs as a freelancer?",
    answer: "Definitely! By focusing on targeted WhatsApp chats instead of pricey ads, you save money while reaching the right people. It’s like getting more bang for your buck!"
  },
  {
    question: "How can I track project progress on WhatsApp?",
    answer: "Send milestone updates, deadlines, and progress reports via WhatsApp. It’s like giving clients a front-row seat to your work, building trust and transparency."
  },
  {
    question: "How do I set up WhatsApp for my freelance business?",
    answer: "Start with WhatsApp Business, create chat templates for proposals and follow-ups, and integrate with tools like ChatMitra. It’s a quick way to supercharge your sales!"
  },
];

const Freelancer = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Skyrocket Your Freelancer and Consultant Sales Using WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                 <a
                 key={index}
                 href={button.buttonLink}
                 className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
               >
                 {button.text}
               </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Freelancer Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Improve your work-life balance and scale your freelance business with WhatsApp. Get started with the WhatsApp Business API using ChatMitra today.</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Freelancercycle />
      <WhatsAppServices servicesData={freelancerServices} isVisible={true}/>
      <Faqs faqs={freelancerFAQs} />
      <title>Boost Freelancer and Consultant Sales with WhatsApp | ChatMitra</title>
      <meta name="description" content="Learn how freelancers and consultants can use WhatsApp to automate FAQs, send secure e-invoices, engage clients, and scale their business without sacrificing work-life balance." />
      <meta name="keywords" content="WhatsApp for freelancers, consultant sales, freelancer marketing, WhatsApp automation, secure e-invoices, client engagement, scale freelance business, ChatMitra" />
      <meta property="og:title" content="Boost Freelancer and Consultant Sales with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Discover how WhatsApp helps freelancers and consultants automate tasks, send secure invoices, and grow their business while maintaining a healthy work-life balance." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-freelancer-and-consultant-sales" />
      <meta property="og:type" content="website" />

      <Footer />
    </>
  );
};

export default Freelancer;